import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  fields: string[];
  translatedMessage: string;
  isDialogOpen: boolean;
  isUpdating: boolean;
};

const initialState: StateInterface = {
  fields: [],
  translatedMessage: "",
  isDialogOpen: false,
  isUpdating: false
};

export const emailAccountsReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_CREATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_UPDATE_FAILURE:
      return {
        ...state,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage
      };

    case Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_DIALOG:
      return {
        ...state,
        ...action.payload,
        fields: action.payload?.isDialogOpen === false ? [] : state.fields,
        translatedMessage: action.payload?.isDialogOpen === false ? "" : state.translatedMessage
      };

    case Constants.PAGE_SETTINGS_EMAIL_ACCOUNT_TOGGLE_UPDATING:
      return {
        ...state,
        isUpdating: action.payload?.isUpdating
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
